import { useQueryParamString } from "polyrouter";

export const SEARCH_API_RESTRICTED_CHARS = /[!\\`~%^&*()={}|[\]]/g;

export const sanitizeSearchInput = (
  input: string,
  restrictedChars = SEARCH_API_RESTRICTED_CHARS
) => input.replace(restrictedChars, "");

export const useSearchTerm = () => {
  return useQueryParamString<string>("searchTerm");
};
